import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useHistory, useParams } from 'react-router';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import areArraysEqual from 'utils/areArraysEqual';
import usePrevious from 'hooks/usePrevious';
var SEGMENT_SEPERATOR = '-';
var DEFAULT_QUERY_KEY = 'selection';
function getIdAsStringOrNumber(id) {
  var idAsNumber = Number(id);
  return isNaN(idAsNumber) ? id : idAsNumber;
}
export var defaultOptions = {
  queryKey: DEFAULT_QUERY_KEY,
  initialState: [],
  basePath: '',
  locationState: undefined
};

/**
 * A hook for syncing selection state (an array of numerical IDs)
 * with a URL query parameter.
 *
 * Optionally, single selections can be reflected in a URL segment parameter.
 *
 * Returns an array containing a selection getter and setter, mimicking React's useState hook
 */

function useSelectionQuery(passedOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), passedOptions);
  var queryKey = options.queryKey,
    initialState = options.initialState,
    urlParamForSingleSelection = options.urlParamForSingleSelection,
    basePath = options.basePath,
    locationState = options.locationState;
  var location = useLocation();
  var history = useHistory();
  var params = useParams();
  var syncMode = useRef('read');
  var singleSelectedItemId = urlParamForSingleSelection && params[urlParamForSingleSelection] ? getIdAsStringOrNumber(params[urlParamForSingleSelection]) : undefined;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    selectionState = _useState2[0],
    setSelectionState = _useState2[1];
  var previousSelectionState = usePrevious(selectionState);
  var _queryparse = queryparse(location.search),
    selectionFromQuery = _queryparse[queryKey];
  var changeSelection = useCallback(function (newSelection) {
    setSelectionState(newSelection);
    syncMode.current = 'write';
  }, []);
  useEffect(function () {
    // Update the URL from current selection state
    if (syncMode.current === 'write') {
      var method = previousSelectionState && previousSelectionState.length > 1 && selectionState.length > 1 ? 'replace' : 'push';
      if (selectionState.length === 1 && urlParamForSingleSelection) {
        var baseLocation = _objectSpread(_objectSpread({}, location), {}, {
          pathname: "".concat(basePath, "/").concat(selectionState.at(0))
        });
        history.push(createLocation(baseLocation, _defineProperty({}, queryKey, undefined)), locationState);
      } else {
        // If a URL parameter is defined for single-selection,
        // remove it from the URL for multi-selections.
        // Otherwise, only update the query parameter.
        var _baseLocation = urlParamForSingleSelection ? _objectSpread(_objectSpread({}, location), {}, {
          pathname: basePath
        }) : location;
        var newLocation = createLocation(_baseLocation, _defineProperty({}, queryKey, selectionState.join(SEGMENT_SEPERATOR) || undefined));
        history[method](newLocation, locationState);
      }
      syncMode.current = 'read';
    } else {
      // Update selection state from URL if needed
      var _newSelection = [];
      if (selectionFromQuery) {
        _newSelection = selectionFromQuery.split(SEGMENT_SEPERATOR).map(getIdAsStringOrNumber);
      }
      if (singleSelectedItemId !== undefined) {
        _newSelection.unshift(singleSelectedItemId);
      }
      var hasSelectionChanged = !areArraysEqual(_newSelection, selectionState, {
        ignoreOrder: true
      });
      if (hasSelectionChanged) {
        setSelectionState(_newSelection);
      }
    }
  }, [selectionState, previousSelectionState, selectionFromQuery, queryKey, location, locationState, history, urlParamForSingleSelection, basePath, singleSelectedItemId]);
  return [selectionState, changeSelection];
}
export default useSelectionQuery;